export default __webpack_public_path__ + "static/media/Avinash-Kishore.da794674.jpeg";